import { padStart } from 'lodash';

export interface Code {
	domain: string;
	number: number;
}

export const formatCode = (code: Code) => `${code.domain}-${padStart(code.number.toFixed(0), 3, '0')}`;
